import { showError } from "../components/ErrorPopup";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/apiClient";
import { SlideshowLightbox } from "lightbox.js-react";
import Resizer from "react-image-file-resizer";
import { PDFDocument } from "pdf-lib";
import { TrashIcon } from "@heroicons/react/solid";
import { XCircleIcon } from "@heroicons/react/solid";
import UsersList from "../components/UsersList";
import { io } from "socket.io-client";
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

const DemandeProjet = ({ user, enabled }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const location = useLocation();
  const [errors, setErrors] = useState({});
  let selectedForm = location.state?.selectedForm;
  const page = location.state?.page;
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [formId, setFormId] = useState(
      location.state?.selectedForm?._id || null
    );
  const navigate = useNavigate(); // Initialize navigate hook

  // const [showTable, setShowTable] = useState(false);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const [loadingAction, setLoadingAction] = useState(null);

  const handleUserSelect = (user, fieldName) => {
  const newUser = {
    nom: user.displayName,
    email: user.mail,
    userId: user.id,
    matricule: user.employeeId,
  };

  const existingUsers = formData[fieldName] || [];

  // éviter les doublons (optionnel mais conseillé)
  const alreadyExists = existingUsers.some(u => u.userId === newUser.userId);
  if (alreadyExists) return;

  handleChange({
    target: {
      name: fieldName,
      value: [...existingUsers, newUser]
    },
  });
};

const handleRemoveUser = (index, fieldName) => {
  const updated = [...(formData[fieldName] || [])];
  updated.splice(index, 1);

  setFormData({
    ...formData,
    [fieldName]: updated
  });
};

  const handleListeImplicationsChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.listeImplications];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        listeImplications: updated,
      };
    });

    setErrors("");
  };

  const handleAddListeImplications = () => {
    setFormData((prev) => ({
      ...prev,
      listeImplications: [
        ...prev.listeImplications,
        {
          service: "",
          nature: "",
        },
      ],
    }));

    setErrors("");
  };

  const handleDeleteListeImplications = (index) => {
    setFormData((prev) => ({
      ...prev,
      listeImplications: prev.listeImplications.filter((_, i) => i !== index),
    }));
  };

  const base64ToFile = (base64, filename, mimeType) => {
    // Remove the base64 data prefix (if it exists)
    const base64String = base64.split(",")[1]; // Get the part after the comma
    if (!base64String) {
      throw new Error("Invalid base64 string");
    }

    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  };

  const handleFileUpload = async (e) => {
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

    const file = e.target.files[0];
    if (!file) return;

    const ALLOWED_TYPES = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!ALLOWED_TYPES.includes(file.type)) {
      setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
      return;
    }

    const resizeImage = (file) =>
      new Promise((resolve) => {
        if (!file.type.includes("image")) return resolve(file);

        Resizer.imageFileResizer(
          file,
          1600,
          1600,
          "WEBP",
          70,
          0,
          (uri) => {
            const resizedFile = new File([uri], file.name, {
              type: "image/webp",
            });
            resolve(resizedFile);
          },
          "blob",
          200,
          200,
        );
      });

    const compressPDF = async (file) => {
      if (file.type !== "application/pdf") return file;

      try {
        const arrayBuffer = await file.arrayBuffer();

        const pdfDoc = await PDFDocument.load(arrayBuffer, {
          ignoreEncryption: false,
        });

        const compressedBytes = await pdfDoc.save();
        return new File([compressedBytes], file.name, {
          type: "application/pdf",
        });
      } catch (error) {
        console.error("Erreur lors du traitement du PDF :", error);

        // PDF protégé ou non lisible → on garde le fichier original
        if (
          error?.message?.toLowerCase().includes("encrypted") ||
          error?.message?.toLowerCase().includes("password") ||
          error?.message?.toLowerCase().includes("decrypt")
        ) {
          setFileUploadError(
            "Ce fichier PDF semble être protégé par mot de passe. Vous pouvez tout de même le joindre, puis indiquer le mot de passe dans le champ prévu à cet effet.",
          );
          return file;
        }

        throw new Error(
          "Le fichier PDF n’a pas pu être traité. Veuillez vérifier le document et réessayer.",
        );
      }
    };

    const processFile = async (file) => {
      if (file.type.includes("image")) {
        return await resizeImage(file);
      } else if (file.type === "application/pdf") {
        return await compressPDF(file);
      }
      return file;
    };

    try {
      const processedFile = await processFile(file);

      if (processedFile.size > MAX_FILE_SIZE) {
        setFileUploadError(
          `Le fichier dépasse la taille maximale permise de ${MAX_FILE_SIZE_MB} Mo.`,
        );
        return;
      }

      setFileUploadError("");
      setUploadedFile(processedFile);
      setFilePreviewUrl(URL.createObjectURL(processedFile));

      setFormData((prev) => ({
        ...prev,
        uploadedFile: {
          filename: processedFile.name,
          contentType: processedFile.type,
          data: "",
        },
      }));

      setErrors("");
    } catch (error) {
      console.error(error);
      setFileUploadError(
        error.message ||
          "Une erreur est survenue lors du téléversement du fichier.",
      );
    }
  };

  const handleFileDelete = () => {
    setUploadedFile(null);
    setFilePreviewUrl(null);
    setShowPopup(false);

    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-DP`;
  };

  const initialFormData = {
    userId: "",
    nom: "",
    numeroFormulaire: generateNumeroFormulaire(),

    etatDemande: "Soumis",
    uploadedFile: null,
    dateSoumission: new Date().toISOString().split("T")[0],
    listeImplications: selectedForm?.listeImplications || [
      {
        service: "",
        nature: "",
      },
    ],

    titreProjet: selectedForm?.titreProjet || "",
    descriptionBesoinOperationnel:
      selectedForm?.descriptionBesoinOperationnel || "",
    alignementPlanStrategiqueConseil:
      selectedForm?.alignementPlanStrategiqueConseil || "",
    championProjet: selectedForm?.championProjet || [],
    responsableProjet: selectedForm?.responsableProjet || [],
    estimationBudgetaire: selectedForm?.estimationBudgetaire || "",
    sourcesFinancement: selectedForm?.sourcesFinancement || "",
    chronologieProjet: selectedForm?.chronologieProjet || "",
    priorite: selectedForm?.priorite || "",
    analyseComplete: selectedForm?.analyseComplete || "",
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);



  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId,
        poste: user.jobTitle,
      }));
    }

    if (selectedForm) {
      if (
        (selectedForm.etatDemande === "Soumis" &&
        page === "Mes taches") || selectedForm.estFerme 
      ) {
        setIsReadOnly(true);
      }

      setFormData((prevData) => ({
        ...prevData,
        userId: selectedForm.userId,
        nom: selectedForm.nom,
        matricule: selectedForm.matricule,
        poste: selectedForm.poste,
        courriel: selectedForm.courriel,
        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission || prevData.dateSoumission,
        etatDemande: selectedForm?.etatDemande || "",

        listeImplications: selectedForm?.listeImplications || [
          {
            service: "",
            nature: "",
          },
        ],
        titreProjet: selectedForm?.titreProjet || "",
        descriptionBesoinOperationnel:
          selectedForm?.descriptionBesoinOperationnel || "",
        alignementPlanStrategiqueConseil:
          selectedForm?.alignementPlanStrategiqueConseil || "",
        championProjet: selectedForm?.championProjet || [],
        responsableProjet: selectedForm?.responsableProjet || [],
        estimationBudgetaire: selectedForm?.estimationBudgetaire || "",
        sourcesFinancement: selectedForm?.sourcesFinancement || "",
        chronologieProjet: selectedForm?.chronologieProjet || "",
        priorite: selectedForm?.priorite || "",
        analyseComplete: selectedForm?.analyseComplete || "",
      }));
    }

    // Prefill dispositions table
    //   if (selectedForm.dispositions && selectedForm.dispositions.length > 0) {
    //     setRows(selectedForm.dispositions); // Populate rows for the table
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       dispositions: selectedForm.dispositions, // Update formData with prefilled dispositions
    //     }));
    //   }
    if (
      selectedForm?.uploadedFile?.data &&
      selectedForm?.uploadedFile?.contentType &&
      selectedForm?.uploadedFile?.filename
    ) {
      const base64String = `data:${selectedForm.uploadedFile.contentType};base64,${selectedForm.uploadedFile.data}`;
      const file = base64ToFile(
        base64String,
        selectedForm.uploadedFile.filename,
        selectedForm.uploadedFile.contentType,
      );

      setUploadedFile(file);
      setFilePreviewUrl(URL.createObjectURL(file));
    }
  }, [user, selectedForm]); // Add selectedForm to the dependency array

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setErrors(""); // reset errors

    setFormData((prevData) => {
      let updatedData = { ...prevData };

      // ✅ Gestion générique
      updatedData[name] = type === "checkbox" ? checked : value;

      // 🔒 EXCLUSIVITÉ DES CHECKBOXES

      return updatedData;
    });
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType, // Action type can be either "Soumettre" or "Enregistrer"
      dateSoumission: currentDate, // Send as a Date object
    };

    const method = formId ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "DemandeProjet";
    const url = formId
      ? `${process.env.REACT_APP_API_BASE_URL}/formFile/${formId}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formFile?form=${formType}`; // Use POST for creating a new form

    // console.log("uploadedFile : ", uploadedFile);

    const formDataToSend = new FormData();

    // Append form data fields to FormData (use JSON.stringify for nested objects if needed)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));
    if (uploadedFile) {
      const blob = new Blob([uploadedFile], { type: uploadedFile.type });
      formDataToSend.append("file", blob, uploadedFile.name);
      // console.log(uploadedFile);
    }
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });
      
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message);
      }
      if(updatedFormData.etatDemande !== "Brouillon"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 3000);
        });
        
        // Store the ID if this was a new form
        if (!formId && data.form?._id) {
          setFormId(data.form._id);
        }

        if (
          updatedFormData.etatDemande !== "Brouillon" &&
          updatedFormData.etatDemande !== ""
        ) {
          const initialFormData = {
            nom: user.displayName,
            userId: user.id,
            numeroFormulaire: generateNumeroFormulaire(),
            // declarationAnnuelle: false,
            // rapportPolice: false,
            coupable: "",
            dateDocumentPolice: "",
            declarationExacteEtComplete: "non",
            typeDemande: "",
            typeDocument: "",
            dateDeclaration: new Date().toISOString().split("T")[0] + "",
            etatDemande: "Soumis",
            traitant: [],
            dateSoumission: "",
            dispositions: [],
          };
          setFormData(initialFormData);

          handleFileDelete();
          // setShowTable(false); here
          setErrors("");

          navigate("/demande", { state: { selectedForm: null } });
        }
        
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }finally {
      setLoadingAction(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (loadingAction) return;

  if (!validateForm()) return;

  setLoadingAction("submit");

  handleFormAction(e, "Soumis");
    // console.log(formData)
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
  };

  const handleSave = (e) => {
   if (loadingAction) return;

  setLoadingAction("save");

  handleFormAction(e, "Brouillon");
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.",
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = "Ce champ est requis.";

    if (!formData.courriel) newErrors.courriel = "Ce champ est requis.";

    if (!formData.poste) newErrors.poste = "Ce champ est requis.";

    if (!formData.titreProjet) newErrors.titreProjet = "Ce champ est requis.";

    if (!formData.descriptionBesoinOperationnel) newErrors.descriptionBesoinOperationnel = "Ce champ est requis.";

    if (!formData.alignementPlanStrategiqueConseil) newErrors.alignementPlanStrategiqueConseil = "Ce champ est requis.";

    if (!formData.championProjet || formData.championProjet.length === 0) newErrors.championProjet = "Veuillez sélectionner au moins un champion du projet.";

    if (!formData.responsableProjet || formData.responsableProjet.length === 0 ) newErrors.responsableProjet = "Veuillez sélectionner un responsable du projet.";

    if (!formData.estimationBudgetaire) newErrors.estimationBudgetaire = "Ce champ est requis.";

    if (!formData.sourcesFinancement) newErrors.sourcesFinancement = "Ce champ est requis.";

    if (!formData.chronologieProjet) newErrors.chronologieProjet = "Ce champ est requis.";

    if (!formData.priorite) newErrors.priorite = "Ce champ est requis.";

    if (!formData.analyseComplete) newErrors.analyseComplete = "Ce champ est requis.";

    if (formData.typeDocument !== "" && !uploadedFile) {
      newErrors.uploadedFile = "Le fichier est obligatoire.";
    }

    if (!formData.listeImplications || formData.listeImplications.length === 0) {
    newErrors.listeImplications = "Veuillez ajouter au moins un service.";
  } else {
    formData.listeImplications.forEach((listeImplication, index) => {
      if (!listeImplication.service || listeImplication.service.trim() === "") {
        newErrors[`listeImplications.${index}.service`] = "Veuillez ajouter un service.";
      }

      if (!listeImplication.nature || listeImplication.nature.trim() === "") {
        newErrors[`listeImplications.${index}.nature`] = "Veuillez ajouter une nature.";
      }

    });
  }

    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/

  if (
    (!enabled && !selectedForm) ||
    (!enabled && selectedForm && selectedForm.etatDemande === "Brouillon")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire Demande de Projet fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé.
        </p>
      </div>
    );
  }
  /************************************************************************/

  return (
    <div className="relative min-h-screen p-8 bg-gray-100 rounded-lg shadow-lg">
      {/* <form
        onSubmit={handleSubmit}
        className="maxn-h-screen p-8 bg-gray-100 rounded-lg shadow-lg"
      > */}
         <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateSoumission"
              name="dateSoumission"
              value={formData.dateSoumission?.split("T")[0] ?? ""}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>

        <div className="w-full flex justify-center mt-6 mb-20">
          <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
            <p className="text-md font-bold flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
                />
              </svg>
              Formulaire demande de projet
            </p>
          </div>
        </div>

        <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
          <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-400 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            Information du membre du personnel
          </p>
        </div>

        <div className="mt-10 w-[100%] grid grid-cols-2 gap-0">
          <div className="w-[75%]">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("nom")}
          </div>

          <div className="w-[75%]">
            <label
              htmlFor="courriel"
              className="block text-sm font-medium text-blue-900"
            >
              Courriel <span className="text-xl text-red-900">*</span> :
            </label>
            <input
              type="text"
              id="courriel"
              name="courriel"
              value={formData.courriel}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("courriel")}
          </div>
        </div>
        <div className="mt-10 w-[100%] grid grid-cols-2 gap-0">
          <div className="w-[75%]">
            <label
              htmlFor="poste"
              className="block text-sm font-medium text-blue-900"
            >
              Poste: <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              id="poste"
              name="poste"
              value={formData.poste}
              readOnly
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("poste")}
          </div>
        </div>
        <div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
          <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.8}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h6m-6 4h6M9 8h3m-6 12h12a2 2 0 002-2V8.414a2 2 0 00-.586-1.414l-2.414-2.414A2 2 0 0015.586 4H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            Détails du Projet
          </p>
        </div>
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-6/5 ">
            <label
              htmlFor="titreProjet"
              className="block text-sm font-medium text-blue-900"
            >
              Titre du projet <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="2"
              id="titreProjet"
              name="titreProjet"
              value={formData.titreProjet}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("titreProjet")}
          </div>
        </div>

        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-6/5 ">
            <label
              htmlFor="descriptionBesoinOperationnel"
              className="block text-sm font-medium text-blue-900"
            >
              Description du besoin opérationnel{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="5"
              id="descriptionBesoinOperationnel"
              name="descriptionBesoinOperationnel"
              value={formData.descriptionBesoinOperationnel}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("descriptionBesoinOperationnel")}
          </div>
        </div>
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-6/5 ">
            <label
              htmlFor="alignementPlanStrategiqueConseil"
              className="block text-sm font-medium text-blue-900"
            >
              Alignement avec le plan stratégique du Conseil{" "}
              <span className="text-xl text-red-900">*</span>: <p className="text-[85%] text-gray-500">Insérez le ou les points applicables du plan stratégique</p>
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="2"
              id="alignementPlanStrategiqueConseil"
              name="alignementPlanStrategiqueConseil"
              value={formData.alignementPlanStrategiqueConseil}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("alignementPlanStrategiqueConseil")}
          </div>
        </div>

<div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
  <div className="w-3/5">
    <label className="block text-sm font-medium text-blue-900 mb-2">
      Champion/Sponsor du projet <span className="text-xl text-red-900">*</span> : <p className="text-[85%] text-gray-500"> Membre de ce qui appuis le projet</p>
    </label>
    { (page !== "Mes taches" && selectedForm?.estFerme !== true) && (
    <div className="relative">
      <UsersList onUserSelect={(user) => handleUserSelect(user, "championProjet")} isRequired={false}/>

    </div>)}
{renderError("championProjet")}
    <div className="flex flex-wrap gap-2 mt-3">
      {formData.championProjet?.map((user, index) => (
        <div
          key={index}
          className="flex items-center gap-2 bg-blue-800 text-white px-3 py-1 rounded-full text-md"
        >
          {user.nom}
          {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
          <button
            type="button"
            onClick={() => handleRemoveUser(index, "championProjet")}
            className="ml-1 text-white hover:text-blue-200"
          >
            ✕
          </button>)}
        </div>
      ))}
    </div>
  </div>
</div>



<div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
  <div className="w-3/5">
    <label className="block text-sm font-medium text-blue-900 mb-2">
      Responsable du projet <span className="text-xl text-red-900">*</span> :  <p className="text-[85%] text-gray-500"> Personne redevable pour la réussite du projet</p>
    </label>
{(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
    <div className="relative">
      <UsersList onUserSelect={(user) => handleUserSelect(user, "responsableProjet")} isRequired={false} />
    </div>)}
      {renderError("responsableProjet")}
    <div className="flex flex-wrap gap-2 mt-3">
      {formData.responsableProjet?.map((user, index) => (
        <div
          key={index}
          className="flex items-center gap-2 bg-green-800 text-white px-3 py-1 rounded-full text-md"
        >
          {user.nom}
          {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
          <button
            type="button"
            onClick={() => handleRemoveUser(index, "responsableProjet")}
            className="ml-1 text-white hover:text-green-200"
          >
            ✕
          </button>)}
        </div>
      ))}
    </div>
  </div>
</div>

        {/* Conditional Table */}
<p className="mt-5 text-gray-500 font-medium mb-4">
  Parties prenantes clés : services, secteurs et écoles impliqués
</p>

        <div className="mt-2 overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-md">
         
          <table className="w-full text-md">
            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="px-4 py-3 text-left w-[30%]">
                  Services/secteurs/écoles
                </th>
                <th className="px-4 py-3 text-left w-[30%]">
                  Nature de l’implication
                </th>
                <th className="px-4 py-3 text-center w-[2%]">Action</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {formData.listeImplications?.map((item, index) => (
                <tr key={index} className="hover:bg-blue-50/40 transition">
                  {/* SERVICES */}
                  <td className="px-4 py-3">
                    <textarea
                      rows={2}
                      placeholder="Saisir (Services/secteurs/écoles)..."
                      readOnly={isReadOnly}
                      className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
          focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                      value={item.service || ""}
                      onChange={(e) =>
                        handleListeImplicationsChange(
                          index,
                          "service",
                          e.target.value,
                        )
                      }
                    />
                    {renderError(`listeImplications.${index}.service`)}
                  </td>

                  {/* NATURE */}
                  <td className="px-4 py-3">
                    <textarea
                      rows={2}
                      placeholder="Saisir la nature de l’implication..."
                      readOnly={isReadOnly}
                      className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
          focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                      value={item.nature || ""}
                      onChange={(e) =>
                        handleListeImplicationsChange(
                          index,
                          "nature",
                          e.target.value,
                        )
                      }
                    />
                    {renderError(`listeImplications.${index}.nature`)}
                  </td>

                  {/* ACTION */}
                  <td className="px-4 py-3 text-center">
                    {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
                    <button
                      type="button"
                      onClick={() => handleDeleteListeImplications(index)}
                      readOnly={isReadOnly}
                      className="inline-flex items-center justify-center p-2 rounded-xl
          hover:bg-red-50 active:scale-95 transition group"
                    >
                      <TrashIcon className="w-5 h-5 text-red-500 group-hover:text-red-600 transition" />
                    </button>)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
{(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
        <div className="mt-6 flex flex-col items-start gap-2">
          <button
            type="button"
            onClick={handleAddListeImplications}
            className="
                  inline-flex items-center gap-2
                  px-6 py-2.5
                  bg-blue-600 hover:bg-blue-700
                  text-white text-sm font-medium
                  rounded-xl
                  shadow-sm hover:shadow-md
                  active:scale-[0.98]
                  transition-all duration-200
                "
          >
            <span className="text-lg leading-none">+</span>
            Ajouter
          </button>
          {renderError("listeImplications")}
        </div>)}

        <div className="mt-10 w-[100%] grid grid-cols-2 gap-0">
          <div className="w-[75%] ">
            <label
              htmlFor="estimationBudgetaire"
              className="block text-sm font-medium text-blue-900"
            >
              Estimation budgétaire{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="2"
              id="estimationBudgetaire"
              name="estimationBudgetaire"
              value={formData.estimationBudgetaire}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("estimationBudgetaire")}
          </div>
          <div className="w-[75%] ">
            <label
              htmlFor="sourcesFinancement"
              className="block text-sm font-medium text-blue-900"
            >
              Sources de financement{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="2"
              id="sourcesFinancement"
              name="sourcesFinancement"
              value={formData.sourcesFinancement}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("sourcesFinancement")}
          </div>
        </div>

        <div className="mt-10 w-[100%] grid grid-cols-2 gap-0">
          <div className="w-[75%] ">
            <label
              htmlFor="chronologieProjet"
              className="block text-sm font-medium text-blue-900"
            >
              Chronologie du projet{" "}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <textarea
              className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="3"
              id="chronologieProjet"
              name="chronologieProjet"
              value={formData.chronologieProjet}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {renderError("chronologieProjet")}
          </div>
        </div>

        <div className="mt-10 w-[100%] grid grid-cols-2 gap-0">
          <div className="w-[75%] ">
            <label
              htmlFor="priorite"
              className="block text-sm font-medium text-blue-900"
            >
              Priorité <span className="text-xl text-red-900">*</span> :
            </label>
            <select
              id="priorite"
              name="priorite"
              value={formData.priorite}
              onChange={handleChange}
              disabled={isReadOnly}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            >
              <option value="">— Séléctionner —</option>
              <option value="Bas">Bas</option>

              <option value="Moyen">Moyen</option>

              <option value="Haut">Haut</option>
            </select>
            {renderError("priorite")}
          </div>
          <div className="w-[75%] ">
            <label
              htmlFor="analyseComplete"
              className="block text-sm font-medium text-blue-900"
            >
              Analyse à compléter{" "}
              <span className="text-xl text-red-900">*</span> :
            </label>
            <select
              id="analyseComplete"
              name="analyseComplete"
              value={formData.analyseComplete}
              disabled={isReadOnly}
              onChange={handleChange}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            >
              <option value="">— Séléctionner —</option>
              <option value="Aucune">Aucune</option>

              <option value="Cas d’affaires">Cas d’affaires</option>

              <option value="Charte de projet">
                Charte de projet
              </option>
            </select>
            {renderError("analyseComplete")}
          </div>
        </div>

        {/* <div className="mt-5 w-3/4 grid grid-cols-2 gap-0 pt-[1.5%]">
                    <div className="w-3/5 ">
                        <label
                            htmlFor="dateDocumentPolice"
                            className="block text-sm font-medium text-blue-900"
                        >

                            Date
                            <span className="text-xl text-red-900"> *</span>
                        </label>
                        <input
                            type="date"
                            id="dateDocumentPolice"
                            name="dateDocumentPolice"
                            value={formData.dateDocumentPolice}
                            onChange={handleChange}
                            min={new Date(
                                new Date().setMonth(new Date().getMonth() - 6)
                            )
                                .toISOString()
                                .split("T")[0]}
                            max={new Date().toISOString().split("T")[0]}
                            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200" />
                        {renderError("dateDocumentPolice")}
                    </div>

                </div> */}

        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
            <label
              htmlFor="fileUpload"
              className="block text-sm font-medium text-blue-900 mb-2"
            >
              Fichier<span className="text-xl text-red-900">*</span> :
            </label>
            {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
            <div className="relative">
              <input
                type="file"
                id="fileUpload"
                name="fileUpload"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileUpload}
                className="absolute inset-0 opacity-0 cursor-pointer"
                readOnly={isReadOnly}
              />
              <button className="w-full px-4 py-2 border border-blue-500 rounded-lg text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 cursor-pointer">
                Choisir un fichier
              </button>
            </div>)}
            {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
            <p className="text-sm text-gray-500 mt-1">
              Formats acceptés : PDF, JPG, JPEG, PNG.
            </p>)}
            {renderError("uploadedFile")}
            {fileUploadError && (
              <p style={{ color: "red", marginTop: "0.5rem" }}>
                {fileUploadError}
              </p>
            )}
          </div>
        </div>

        {uploadedFile && (
          <div className="mt-3 w-3/4 flex items-center space-x-4">
            {/* View Document Button */}
            <p
              className="border rounded-lg px-4 py-2 w-[30%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
              onClick={() => setShowPopup(true)}
            >
              <span className="font-medium">Voir le document: </span>
              {uploadedFile.name}
            </p>

            {/* Delete File Button with Trash Icon */}
            {(page !== "Mes taches" && selectedForm?.estFerme !== true)  && (
            <button
              onClick={handleFileDelete}
              className="w-10 h-10 border border-red-500 text-red-600 rounded-lg flex items-center justify-center transition duration-200"
            >
              <TrashIcon className="w-7 h-7" /> {/* Heroicons Trash Icon */}
            </button>)}
          </div>
        )}

        {/* Popup with file preview */}
        {showPopup && uploadedFile && (
          <>
            {/* Background overlay */}
            <div
              className="fixed  inset-0 bg-black bg-opacity-50 z-40"
              onClick={closePopup}
            ></div>

            {/* Centered popup */}
            <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">
                    Aperçu du fichier
                  </h3>
                  {uploadedFile.type.startsWith("image/") && (
                    <p className="text-sm text-gray-500">
                      Cliquez sur l’image pour l’agrandir
                    </p>
                  )}
                </div>
                <button
                  onClick={closePopup}
                  className="text-gray-500 hover:text-gray-700 font-bold text-xl"
                >
                  X
                </button>
              </div>

              {/* Display preview based on file type */}
              {uploadedFile.type.startsWith("image/") && (
                <>
                  <SlideshowLightbox className="mx-auto">
                    <img
                      src={filePreviewUrl}
                      alt="Aperçu"
                      className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                    />
                  </SlideshowLightbox>
                </>
              )}

              {uploadedFile.type === "application/pdf" && (
                <iframe
                  src={filePreviewUrl}
                  title="PDF preview"
                  className="w-[100%] h-[90%] border mt-4"
                ></iframe>
              )}

              {!uploadedFile.type.startsWith("image/") &&
                !uploadedFile.type.includes("pdf") && (
                  <p className="text-sm text-gray-800 mt-4">
                    Preview not available for this file type.
                  </p>
                )}
            </div>
          </>
        )}

        {/* Privacy Statement */}
  
          <div className="flex justify-start mt-4">
            {/* Left-aligned Buttons */}
            <div className="flex gap-4 mt-6">
              {/* Save Button */}
              {/* Reset Button */}
              {/* {(selectedForm?.etatDemande !== "Soumis") && (
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
            >
              Réinitialiser
            </button>)} */}

              {selectedForm?.etatDemande !== "Soumis" && (
                <button
                  type="button"
                  onClick={handleSave}
                  disabled={loadingAction !== null}
                  className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-gray-700 text-white hover:bg-gray-600 active:scale-95"
                    }
                    `}
                >
                  {/* {isSubmitting && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    )} */}
                  {loadingAction === "save" && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  )}
                  Enregistrer
                </button>
              )}

              {/* Soumettre */}
              { (page !== "Mes taches" && selectedForm?.estFerme !== true) &&(
              <button
                type="button"
              onClick={handleSubmit}
                disabled={loadingAction !== null}
                className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-green-300 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-500 active:scale-95"
                    }
                `}
              >
                {loadingAction === "submit" && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Soumettre
              </button>)}

            </div>
          </div>
        
        {/* </>)} */}
      {/* </form> */}
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemandeProjet;
